// extracted by mini-css-extract-plugin
export default {"container":"document-item_container__xpxz7","info":"document-item_info__jdD55"};